var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00748 4.76524C7.55565 4.47328 7.01295 4.38504 6.50391 4.5052L15.4495 13.4508L18.3488 10.5515L8.00748 4.76524Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3931 5.23438C5.1436 5.56608 5 5.97336 5 6.40419V22.339C5 22.7698 5.14364 23.1771 5.3931 23.5088L14.5303 14.3716L5.3931 5.23438Z",
    fill: "#98A2B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1316 12.6689L19.526 11.2109L16.3672 14.3697L19.5261 17.5286L22.1321 16.0706C22.7564 15.7208 23.1291 15.085 23.1291 14.3697C23.1291 13.6544 22.7564 13.0187 22.1316 12.6689Z",
    fill: "#98A2B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.449 15.2891L6.50391 24.2341C6.65056 24.2686 6.79982 24.2872 6.94907 24.2872C7.31793 24.2872 7.6855 24.1823 8.00698 23.9746L18.3484 18.1884L15.449 15.2891Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.23d71c7277bd479b659273b4f0abbc7a.svg";
export { ForwardRef as ReactComponent };